import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./OneDriveOptions.css";

function OneDriveOptions({ onAddFile, onAddFolder, onClose, canCreateFolder = true }) {
  const { t } = useTranslation("assistantConfiguration");
  const [isFileHovered, setIsFileHovered] = useState(false);
  const [isFolderHovered, setIsFolderHovered] = useState(false);

  return (
    <div className="onedrive-options-container">
      <button
        className="onedrive-options-close"
        onClick={onClose}
        aria-label="Fechar"
      >
        <img src="/imagens/x.svg" alt="Close" />
      </button>

      <div className="onedrive-options-wrapper">
        <button
          className="btn-create-file"
          onClick={onAddFile}
          onMouseEnter={() => setIsFileHovered(true)}
          onMouseLeave={() => setIsFileHovered(false)}
        >
          <img
            src={
              isFileHovered
                ? "/imagens/create-classifier-white.svg"
                : "/imagens/create-classifier.svg"
            }
            className="img-create-file"
            alt={t("add_file_title")}
          />
          <h3 className="btn-create-title">{t("add_file_title")}</h3>
          <p className="btn-create-paragraph">{t("add_file_description")}</p>
        </button>

        <button
          className="btn-create-folder"
          onClick={onAddFolder}
          onMouseEnter={() => !canCreateFolder || setIsFolderHovered(true)}
          onMouseLeave={() => !canCreateFolder || setIsFolderHovered(false)}
          disabled={!canCreateFolder}
        >
          <img
            src={
              isFolderHovered
                ? "/imagens/add-folder-white.svg"
                : "/imagens/add-folder.svg"
            }
            className="img-create-folder"
            alt={t("add_folder_title")}
          />
          <h3 className="btn-create-title">{t("add_folder_title")}</h3>
          <p className="btn-create-paragraph">{t("add_folder_description")}</p>
        </button>
      </div>
    </div>
  );
}

export default OneDriveOptions;
